/**
 * Supabase Edge Function endpoints used by the public website.
 *
 * These replace the Express routes that used to live on Render:
 *   POST /api/contact         -> send-contact-email
 *   POST /api/analytics/track -> track-visitor
 *
 * Both functions are declared `verify_jwt = false` in
 * mobile-app/supabase/config.toml, so the website calls them without a signed-in
 * user. The anon key is still sent when configured — it is a public,
 * RLS-constrained key and is safe to ship in the bundle.
 */

const SUPABASE_URL =
  process.env.REACT_APP_SUPABASE_URL || 'https://sopcklmmslydqnenxxfx.supabase.co';
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY || '';

export const functionUrl = (name: string): string =>
  `${SUPABASE_URL.replace(/\/$/, '')}/functions/v1/${name}`;

export const functionHeaders = (): Record<string, string> => {
  const headers: Record<string, string> = { 'Content-Type': 'application/json' };
  if (SUPABASE_ANON_KEY) {
    headers.apikey = SUPABASE_ANON_KEY;
    headers.Authorization = `Bearer ${SUPABASE_ANON_KEY}`;
  }
  return headers;
};
